import React from 'react'

export default function HomeGrace() {
  return (
    <>
    <section className="homegrace">
        <div className="homegrace-text">
            <h3 className='heading'>Grace in Every Ensemble</h3>
        </div>

        <img src="/image/grace-banner.webp" className="img-responsive" alt="grace" loading="lazy"/>
        <div className="homegrace-overlay"></div>
    </section> 
    </>
  )
}
